import rwd from '../img/rwd.svg';
import webImg from '../img/web.svg';
import webAppImg from '../img/resweb.svg';

export default function Services(){
    return(
        <section className='services'>
          <svg className='wave3' xmlns="http://www.w3.org/2000/svg" viewBox="0 100 1440 220"><path fill="#ffffff" fill-opacity="1" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,250.7C1248,256,1344,288,1392,304L1440,320L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>

          <h3 className='sectionTitle' id='services'> {" What I do ? (Services)"} </h3>
          <div className='serv'>
            <div>
                <div>
                    <img src={rwd} alt='' />
                </div>
                <strong> Responsive Web Development </strong>
                <p>
                    {"Portifolios, Landing Pages, ..."}
                </p>
            </div>
            <div>
                <div>
                    <img src={webAppImg} alt='' />
                </div>
                <strong> WebApp Development </strong>
                <p>
                    {"PWA´s, Management Systems, ..."}
                </p>
            </div>
            <div>
                <div>
                    <img src={webImg} alt='' />
                </div>
                <strong> SEO  </strong>
                <p>
                    {"SEO On-Page, Technical SEO, ..."}
                </p>
            </div>
          </div>
        </section>
    );
}